/**
 * Copyright (C) 2024-present Puter Technologies Inc.
 *
 * Ez a fájl a Puter része.
 *
 * A Puter szabad szoftver: terjesztheted és/vagy módosíthatod
 * a GNU Affero General Public License feltételei szerint, amelyet a Free Software Foundation adott ki, akár a licenc 3-as verziója, akár (választásod szerint) bármely későbbi verzió alapján.
 *
 * Ez a program abban a reményben kerül terjesztésre, hogy hasznos lesz,
 * de mindenféle GARANCIA NÉLKÜL; még az ELADHATÓSÁGRA vagy egy adott célra való ALKALMASSÁG hallgatólagos garanciája nélkül is. További részletekért lásd a GNU Affero General Public License-t.
 *
 * A programhoz mellékelték a GNU Affero General Public License egy példányát.
 * Ha nem, látogass el a <https://www.gnu.org/licenses/> oldalra.
 */

const hu = {
    name: "Magyar",
    english_name: "Hungarian",
    code: "hu",
    dictionary: {
        about: "Névjegy",
        account: "Fiók",
        account_password: "Fiók jelszó megerősítése",
        access_granted_to: "Hozzáférés engedélyezve",
        add_existing_account: "Meglévő fiók hozzáadása",
        all_fields_required: "Minden mező kitöltése kötelező.",
        allow: "Engedélyez",
        apply: "Alkalmaz",
        ascending: "Növekvő",
        associated_websites: "Kapcsolódó weboldalak",
        auto_arrange: "Automatikus elrendezés",
        background: "Háttér",
        browse: "Böngészés",
        cancel: "Mégsem",
        center: "Középre",
        change_desktop_background: "Asztal háttérképének módosítása...",
        change_email: "Email módosítása",
        change_language: "Nyelv módosítása",
        change_password: "Jelszó módosítása",
        change_ui_colors: "UI színek módosítása",
        change_username: "Felhasználónév módosítása",
        close: "Bezár",
        close_all_windows: "Minden ablak bezárása",
        close_all_windows_confirm: "Biztosan be akarod zárni az összes ablakot?",
        close_all_windows_and_log_out: "Ablakok bezárása és kijelentkezés",
        change_always_open_with: "Mindig ezzel az alkalmazással nyitja meg ezt a fájlt?",
        color: "Szín",
        confirm: "Megerősít",
        confirm_2fa_setup: "A kódot hozzáadtam a hitelesítő alkalmazásomhoz",
        confirm_2fa_recovery: "A helyreállítási kódokat biztonságos helyen tároltam",
        confirm_account_for_free_referral_storage_c2a: "Hozz létre egy fiókot és erősítsd meg email címedet, hogy 1 GB ingyenes tárhelyet kapj. A barátod is kap 1 GB ingyenes tárhelyet.",
        confirm_code_generic_incorrect: "Hibás kód.",
        confirm_code_generic_too_many_requests: "Túl sok kérés. Kérlek, várj néhány percet.",
        confirm_code_generic_submit: "Kód beküldése",
        confirm_code_generic_try_again: "Próbáld újra",
        confirm_code_generic_title: "Megerősítő kód megadása",
        confirm_code_2fa_instruction: "Add meg a 6-jegyű kódot a hitelesítő alkalmazásodból.",
        confirm_code_2fa_submit_btn: "Beküldés",
        confirm_code_2fa_title: "2FA kód megadása",
        confirm_delete_multiple_items: "Biztosan véglegesen törölni akarod ezeket az elemeket?",
        confirm_delete_single_item: "Biztosan véglegesen törölni akarod ezt az elemet?",
        confirm_open_apps_log_out: "Nyitott alkalmazásaid vannak. Biztosan ki akarsz jelentkezni?",
        confirm_new_password: "Új jelszó megerősítése",
        confirm_delete_user: "Biztosan törölni akarod a fiókodat? Minden fájlod és adatod véglegesen törlődik. Ez a művelet nem visszavonható.",
        confirm_delete_user_title: "Fiók törlése?",
        confirm_session_revoke: "Biztosan visszavonod ezt a munkamenetet?",
        confirm_your_email_address: "Email címed megerősítése",
        contact_us: "Kapcsolat",
        contact_us_verification_required: "A használathoz érvényesített email címmel kell rendelkezned.",
        contain: "Tartalmaz",
        continue: "Folytatás",
        copy: "Másolás",
        copy_link: "Link másolása",
        copying: "Másolás",
        copying_file: "Másolás: %%",
        cover: "Borító",
        create_account: "Fiók létrehozása",
        create_free_account: "Ingyenes fiók létrehozása",
        create_shortcut: "Parancsikon létrehozása",
        credits: "Kreditek",
        current_password: "Jelenlegi jelszó",
        cut: "Kivágás",
        clock: "Óra",
        clock_visible_hide: "Elrejt - Mindig rejtett",
        clock_visible_show: "Megjelenít - Mindig látható",
        clock_visible_auto: "Automatikus - Alapértelmezett, csak teljes képernyős módban látható.",
        close_all: "Összes bezárása",
        created: "Létrehozva",
        date_modified: "Módosítás dátuma",
        default: "Alapértelmezett",
        delete: "Törlés",
        delete_account: "Fiók törlése",
        delete_permanently: "Végleges törlés",
        deleting_file: "Törlés: %%",
        deploy_as_app: "Alkalmazásként telepít",
        descending: "Csökkenő",
        desktop: "Asztal",
        desktop_background_fit: "Illesztés",
        developers: "Fejlesztők",
        dir_published_as_website: "%strong% közzétéve a következő címen:",
        disable_2fa: "2FA letiltása",
        disable_2fa_confirm: "Biztosan letiltod a 2FA-t?",
        disable_2fa_instructions: "Add meg a jelszavad a 2FA letiltásához.",
        disassociate_dir: "Könyvtár leválasztása",
        documents: "Dokumentumok",
        dont_allow: "Nem engedélyez",
        download: "Letöltés",
        download_file: "Fájl letöltése",
        downloading: "Letöltés",
        email: "Email",
        email_change_confirmation_sent: "Megerősítő emailt küldtünk az új email címedre. Kérlek, ellenőrizd a postaládádat és kövesd az utasításokat a folyamat befejezéséhez.",
        email_invalid: "Érvénytelen email cím.",
        email_or_username: "Email vagy Felhasználónév",
        email_required: "Email szükséges.",
        empty_trash: "Kuka ürítése",
        empty_trash_confirmation: "Biztosan véglegesen törölni akarod a Kukában lévő elemeket?",
        emptying_trash: "Kuka ürítése...",
        enable_2fa: "2FA engedélyezése",
        end_hard: "Kemény befejezés",
        end_process_force_confirm: "Biztosan kényszerített kilépést hajtasz végre erre a folyamatra?",
        end_soft: "Lágy befejezés",
        enlarged_qr_code: "Nagyított QR kód",
        enter_password_to_confirm_delete_user: "Add meg a jelszavad a fiók törlésének megerősítéséhez",
        error_message_is_missing: "Hiányzik a hibaüzenet.",
        error_unknown_cause: "Ismeretlen hiba történt.",
        error_uploading_files: "Fájlok feltöltése sikertelen",
        favorites: "Kedvencek",
        feedback: "Visszajelzés",
        feedback_c2a: "Kérlek, használd az alábbi űrlapot, hogy elküldd nekünk visszajelzésedet, észrevételeidet és hibajelentéseidet.",
        feedback_sent_confirmation: "Köszönjük, hogy kapcsolatba léptél velünk. Ha van email címed a fiókodhoz társítva, hamarosan hallani fogsz rólunk.",
        fit: "Illesztés",
        folder: "Mappa",
        force_quit: "Kényszerített kilépés",
        forgot_pass_c2a: "Elfelejtetted a jelszavad?",
        from: "Tól",
        general: "Általános",
        get_a_copy_of_on_puter: "Szerezz egy példányt a(z) '%%' Puter.com-on!",
        get_copy_link: "Másolási link megszerzése",
        hide_all_windows: "Minden ablak elrejtése",
        home: "Otthon",
        html_document: "HTML dokumentum",
        hue: "Színárnyalat",
        image: "Kép",
        incorrect_password: "Helytelen jelszó",
        invite_link: "Meghívó link",
        item: "elem",
        items_in_trash_cannot_be_renamed: "Ez az elem nem nevezhető át, mert a kukában van. A név megváltoztatásához először húzd ki a Kukából.",
        jpeg_image: "JPEG kép",
        keep_in_taskbar: "Tartsa a tálcán",
        language: "Nyelv",
        license: "Licenc",
        lightness: "Világosság",
        link_copied: "Link másolva",
        loading: "Betöltés",
        log_in: "Bejelentkezés",
        log_into_another_account_anyway: "Bejelentkezés egy másik fiókba",
        log_out: "Kijelentkezés",
        looks_good: "Jól néz ki!",
        manage_sessions: "Munkamenetek kezelése",
        modified: "Módosítva",
        move: "Mozgatás",
        moving_file: "Mozgatás: %%",
        my_websites: "Saját weboldalaim",
        name: "Név",
        name_cannot_be_empty: "A név nem lehet üres.",
        name_cannot_contain_double_period: "A név nem tartalmazhatja a '..' karaktert.",
        name_cannot_contain_period: "A név nem tartalmazhatja a '.' karaktert.",
        name_cannot_contain_slash: "A név nem tartalmazhatja a '/' karaktert.",
        name_must_be_string: "A név csak szöveg lehet.",
        name_too_long: "A név nem lehet hosszabb, mint %% karakter.",
        new: "Új",
        new_email: "Új email",
        new_folder: "Új mappa",
        new_password: "Új jelszó",
        new_username: "Új felhasználónév",
        no: "Nem",
        no_dir_associated_with_site: "Ehhez a címhez nincs társítva könyvtár.",
        no_websites_published: "Még nem publikáltál egyetlen weboldalt sem. Kattints jobb gombbal egy mappára a kezdéshez.",
        ok: "Rendben",
        open: "Megnyitás",
        open_in_new_tab: "Megnyitás új lapon",
        open_in_new_window: "Megnyitás új ablakban",
        open_with: "Megnyitás ezzel",
        original_name: "Eredeti név",
        original_path: "Eredeti útvonal",
        oss_code_and_content: "Nyílt forráskódú szoftver és tartalom",
        password: "Jelszó",
        password_changed: "Jelszó megváltoztatva.",
        password_recovery_rate_limit: "Elérted a korlátunkat; kérlek, várj néhány percet. A jövőben kerüld az oldal túl sokszori újratöltését.",
        password_recovery_token_invalid: "Ez a jelszó visszaállítási token már nem érvényes.",
        password_recovery_unknown_error: "Ismeretlen hiba történt. Kérlek, próbáld újra később.",
        password_required: "Jelszó szükséges.",
        password_strength_error: "A jelszónak legalább 8 karakter hosszúnak kell lennie és tartalmaznia kell legalább egy nagybetűt, egy kisbetűt, egy számot és egy speciális karaktert.",
        passwords_do_not_match: "'Új jelszó' és 'Új jelszó megerősítése' nem egyeznek.",
        paste: "Beillesztés",
        paste_into_folder: "Beillesztés a mappába",
        path: "Útvonal",
        personalization: "Személyre szabás",
        pick_name_for_website: "Válassz nevet a weboldaladnak:",
        picture: "Kép",
        pictures: "Képek",
        plural_suffix: "k",
        powered_by_puter_js: "A Puter.js hajtja",
        preparing: "Előkészítés...",
        preparing_for_upload: "Feltöltés előkészítése...",
        print: "Nyomtatás",
        privacy: "Adatvédelem",
        proceed_to_login: "Folytatás a bejelentkezéshez",
        proceed_with_account_deletion: "Fiók törlésének folytatása",
        process_status_initializing: "Inicializálás",
        process_status_running: "Fut",
        process_type_app: "Alkalmazás",
        process_type_init: "Inicializálás",
        process_type_ui: "Felhasználói felület",
        properties: "Tulajdonságok",
        public: "Nyilvános",
        publish: "Közzététel",
        publish_as_website: "Közzététel weboldalként",
        puter_description: "A Puter egy adatvédelmi elsőként kezelt személyes felhő, amelyben minden fájlodat, alkalmazásodat és játékodat egy biztonságos helyen tárolhatod, bárhonnan, bármikor elérhetően.",
        reading_file: "Fájl olvasása: %strong%",
        recent: "Legutóbbi",
        recommended: "Ajánlott",
        recover_password: "Jelszó visszaállítása",
        refer_friends_c2a: "Kapj 1 GB-ot minden barátodért, aki létrehoz és megerősít egy fiókot a Puteren. A barátod is kap 1 GB-ot!",
        refer_friends_social_media_c2a: "Kapj 1 GB ingyenes tárhelyet a Puter.com-on!",
        refresh: "Frissítés",
        release_address_confirmation: "Biztosan felszabadítod ezt a címet?",
        remove_from_taskbar: "Eltávolítás a tálcáról",
        rename: "Átnevezés",
        repeat: "Ismétlés",
        replace: "Csere",
        replace_all: "Összes cseréje",
        resend_confirmation_code: "Megerősítő kód újraküldése",
        reset_colors: "Színek visszaállítása",
        restart_puter_confirm: "Biztosan újraindítod a Putert?",
        restore: "Visszaállítás",
        save: "Mentés",
        saturation: "Telítettség",
        save_account: "Fiók mentése",
        save_account_to_get_copy_link: "A folytatáshoz kérlek, hozz létre egy fiókot.",
        save_account_to_publish: "A folytatáshoz kérlek, hozz létre egy fiókot.",
        save_session: "Munkamenet mentése",
        save_session_c2a: "Hozz létre egy fiókot, hogy mentsd az aktuális munkamenetedet és elkerüld a munkád elvesztését.",
        scan_qr_c2a: "Olvasd be az alábbi kódot, hogy bejelentkezhess ebbe a munkamenetbe más eszközökről",
        scan_qr_2fa: "Olvasd be a QR-kódot a hitelesítő alkalmazásoddal",
        scan_qr_generic: "Olvasd be ezt a QR-kódot a telefonoddal vagy más eszközzel",
        search: "Keresés",
        seconds: "másodperc",
        security: "Biztonság",
        select: "Kiválasztás",
        selected: "kiválasztva",
        select_color: "Szín kiválasztása...",
        sessions: "Munkamenetek",
        send: "Küldés",
        send_password_recovery_email: "Jelszó visszaállító email küldése",
        session_saved: "Köszönjük, hogy létrehoztál egy fiókot. Ez a munkamenet mentésre került.",
        settings: "Beállítások",
        set_new_password: "Új jelszó beállítása",
        share: "Megosztás",
        share_to: "Megosztás ide:",
        share_with: "Megosztás valakivel:",
        shortcut_to: "Parancsikon ide:",
        show_all_windows: "Összes ablak megjelenítése",
        show_hidden: "Rejtett megjelenítése",
        sign_in_with_puter: "Bejelentkezés Puterrel",
        sign_up: "Regisztráció",
        signing_in: "Bejelentkezés...",
        size: "Méret",
        skip: "Kihagyás",
        something_went_wrong: "Valami hiba történt.",
        sort_by: "Rendezés",
        start: "Indítás",
        status: "Állapot",
        storage_usage: "Tárhely használat",
        storage_puter_used: "Puter által használt",
        taking_longer_than_usual: "Kicsit tovább tart, mint általában. Kérlek várj...",
        task_manager: "Feladatkezelő",
        taskmgr_header_name: "Név",
        taskmgr_header_status: "Állapot",
        taskmgr_header_type: "Típus",
        terms: "Feltételek",
        text_document: "Szöveges dokumentum",
        tos_fineprint: "A 'Ingyenes fiók létrehozása' gombra kattintva elfogadod a Puter {{link=terms}}Szolgáltatási feltételeit{{/link}} és {{link=privacy}}Adatvédelmi irányelveit{{/link}}.",
        transparency: "Átlátszóság",
        trash: "Kuka",
        two_factor: "Kétfaktoros hitelesítés",
        two_factor_disabled: "2FA letiltva",
        two_factor_enabled: "2FA engedélyezve",
        type: "Típus",
        type_confirm_to_delete_account: "Írd be, hogy 'megerősít' a fiók törléséhez.",
        ui_colors: "UI színek",
        ui_manage_sessions: "Munkamenetkezelő",
        ui_revoke: "Visszavonás",
        undo: "Visszavonás",
        unlimited: "Korlátlan",
        unzip: "Kibontás",
        upload: "Feltöltés",
        upload_here: "Feltöltés ide",
        usage: "Használat",
        username: "Felhasználónév",
        username_changed: "A felhasználónév sikeresen frissítve.",
        username_required: "Felhasználónév szükséges.",
        versions: "Verziók",
        videos: "Videók",
        visibility: "Láthatóság",
        yes: "Igen",
        yes_release_it: "Igen, Engedd El",
        you_have_been_referred_to_puter_by_a_friend: "Egy barátod ajánlott téged a Puterhez!",
        zip: "Zip",
        zipping_file: "Tömörítés: %strong%",

        // === 2FA Setup ===
        setup2fa_1_step_heading: "Nyisd meg a hitelesítő alkalmazásod",
        setup2fa_1_instructions: "Bármely hitelesítő alkalmazást használhatod, amely támogatja az időalapú egyszeri jelszó (TOTP) protokollt. Sok választási lehetőség van, de ha nem vagy biztos benne, az <a target='_blank' href='https://authy.com/download'>Authy</a> jó választás Android és iOS rendszeren.",
        setup2fa_2_step_heading: "Olvasd be a QR-kódot",
        setup2fa_3_step_heading: "Add meg a 6-jegyű kódot",
        setup2fa_4_step_heading: "Másold le a helyreállítási kódjaidat",
        setup2fa_4_instructions: "Ezek a helyreállítási kódok az egyetlen módja annak, hogy hozzáférj a fiókodhoz, ha elveszíted a telefonodat vagy nem tudod használni a hitelesítő alkalmazásodat. Ügyelj arra, hogy biztonságos helyen tárold őket.",
        setup2fa_5_step_heading: "2FA beállítás megerősítése",
        setup2fa_5_confirmation_1: "A helyreállítási kódokat biztonságos helyen tároltam",
        setup2fa_5_confirmation_2: "Készen állok a 2FA engedélyezésére",
        setup2fa_5_button: "2FA engedélyezése",

        // === 2FA Login ===
        login2fa_otp_title: "2FA kód megadása",
        login2fa_otp_instructions: "Add meg a 6-jegyű kódot a hitelesítő alkalmazásodból.",
        login2fa_recovery_title: "Add meg egy helyreállítási kódot",
        login2fa_recovery_instructions: "Add meg az egyik helyreállítási kódodat a fiókhoz való hozzáféréshez.",
        login2fa_use_recovery_code: "Használj helyreállítási kódot",
        login2fa_recovery_back: "Vissza",
        login2fa_recovery_placeholder: "XXXXXXXX",

        "change": "Módosítás", // In English: "Change"
        "clock_visibility": "Óra Megjelenítése", // In English: "Clock Visibility"
        "reading": "Olvasás %strong%", // In English: "Reading %strong%"
        "writing": "Írás %strong%", // In English: "Writing %strong%"
        "unzipping": "Kibontás %strong%", // In English: "Unzipping %strong%"
        "sequencing": "Sorba rendezés %strong%", // In English: "Sequencing %strong%"
        "zipping": "Tömörítés %strong%", // In English: "Zipping %strong%"
        "Editor": "Szerkesztő", // In English: "Editor"
        "Viewer": "Megtekintő", // In English: "Viewer"
        "People with access": "Hozzáféréssel rendelkező emberek", // In English: "People with access"
        "Share With…": "Oszd Meg…", // In English: "Share With…"
        "Owner": "Tulajdonos", // In English: "Owner"
        "You can't share with yourself.": "Nem oszthatod meg magaddal.", // In English: "You can't share with yourself."
        "This user already has access to this item": "Ez a felhasználó már hozzáfér ehhez az elemhez", // In English: "This user already has access to this item"

        "billing.change_payment_method": "Módosítás", // In English: "Change"
        "billing.cancel": "Lemondás", // In English: "Cancel"
        "billing.change_payment_method": "Fizetési mód megváltoztatása", // In English: "Change"
        "billing.cancel": "Mégse", // In English: "Cancel"
        "billing.download_invoice": "Letöltés", // In English: "Download"
        "billing.payment_method": "Fizetési mód", // In English: "Payment Method"
        "billing.payment_method_updated": "A fizetési mód frissítve!", // In English: "Payment method updated!"
        "billing.confirm_payment_method": "Fizetési mód megerősítése", // In English: "Confirm Payment Method"
        "billing.payment_history": "Fizetési előzmények", // In English: "Payment History"
        "billing.refunded": "Visszatérítve", // In English: "Refunded"
        "billing.paid": "Fizetve", // In English: "Paid"
        "billing.ok": "OK", // In English: "OK"
        "billing.resume_subscription": "Előfizetés folytatása", // In English: "Resume Subscription"
        "billing.subscription_cancelled": "Az előfizetésed lemondva.", // In English: "Your subscription has been canceled."
        "billing.subscription_cancelled_description": "Az aktuális számlázási időszak végéig továbbra is hozzáférsz az előfizetésedhez.", // In English: "You will still have access to your subscription until the end of this billing period."
        "billing.offering.free": "Ingyenes", // In English: "Free"
        "billing.offering.pro": "Professzionális", // In English: "Professional"
        "billing.offering.professional": "Professzionális", // In English: "Professional"
        "billing.offering.business": "Üzleti", // In English: "Business"
        "billing.cloud_storage": "Felhő Tárhely", // In English: "Cloud Storage"
        "billing.ai_access": "AI hozzáférés", // In English: "AI Access"
        "billing.bandwidth": "Sávszélesség", // In English: "Bandwidth"
        "billing.apps_and_games": "Alkalmazások és játékok", // In English: "Apps & Games"
        "billing.upgrade_to_pro": "Csomag váltása erre: %strong%", // In English: "Upgrade to %strong%"
        "billing.switch_to": "Váltás erre: %strong%", // In English: "Switch to %strong%"
        "billing.payment_setup": "Fizetési beállítás", // In English: "Payment Setup"
        "billing.back": "Vissza", // In English: "Back"
        "billing.you_are_now_subscribed_to": "Mostantól feliratkoztál a %strong% csomagra.", // In English: "You are now subscribed to %strong% tier."
        "billing.you_are_now_subscribed_to_without_tier": "Mostantól előfizettél", // In English: "You are now subscribed"
        "billing.subscription_cancellation_confirmation": "Biztos, hogy le akarod mondani az előfizetésedet?", // In English: "Are you sure you want to cancel your subscription?"
        "billing.subscription_setup": "Előfizetés beállítása", // In English: "Subscription Setup"
        "billing.cancel_it": "Mondd le", // In English: "Cancel It"
        "billing.keep_it": "Tartsd meg", // In English: "Keep It"
        "billing.subscription_resumed": "A(z) %strong% előfizetésed folytatva lett!", // In English: "Your %strong% subscription has been resumed!"
        "billing.upgrade_now": "Válts magasabb csomagra most", // In English: "Upgrade Now"
        "billing.upgrade": "Csomag Váltása", // In English: "Upgrade"
        "billing.currently_on_free_plan": "Jelenleg az ingyenes csomagon vagy.", // In English: "You are currently on the free plan."
        "billing.download_receipt": "Nyugta letöltése", // In English: "Download Receipt"
        "billing.subscription_check_error": "Hiba történt az előfizetési állapot ellenőrzése közben.", // In English: "A problem occurred while checking your subscription status."
        "billing.email_confirmation_needed": "Az e-mail címed még nincs megerősítve. Most küldünk egy kódot a megerősítéshez.", // In English: "Your email has not been confirmed. We'll send you a code to confirm it now."
        "billing.sub_cancelled_but_valid_until": "Lemondtad az előfizetésedet, és a számlázási időszak végén automatikusan az ingyenes csomagra vált. Nem fogsz újra díjat fizetni, hacsak nem fizetsz elő újra.", // In English: "You have cancelled your subscription and it will automatically switch to the free tier at the end of the billing period. You will not be charged again unless you re-subscribe."
        "billing.current_plan_until_end_of_period": "Az aktuális csomagod a számlázási időszak végéig.", // In English: "Your current plan until the end of this billing period."
        "billing.current_plan": "Jelenlegi csomag", // In English: "Current plan"
        "billing.cancelled_subscription_tier": "Lemondott Előfizetés (%%)", // In English: "Cancelled Subscription (%%)"
        "billing.manage": "Kezelés", // In English: "Manage"
        "billing.limited": "Korlátozott", // In English: "Limited"
        "billing.expanded": "Bővített", // In English: "Expanded"
        "billing.accelerated": "Gyorsított", // In English: "Accelerated"
        "billing.enjoy_msg": "Élvezd a %% Felhőtárhelyet és további előnyöket.", // In English: "Enjoy %% of Cloud Storage plus other benefits."
        "choose_publishing_option": "Válassza ki, hogyan szeretné közzétenni a webhelyét", // English: "Choose how you want to publish your website"
        "create_desktop_shortcut": "Parancsikon létrehozása (Asztal)", // English: "Create Shortcut (Desktop)"
        "create_desktop_shortcut_s": "Parancsikonok létrehozása (Asztal)", // English: "Create Shortcuts (Desktop)"
        "create_shortcut_s": "Parancsikonok létrehozása", // English: "Create Shortcuts"
        "minimize": "Minimalizálás", // English: "Minimize"
        "reload_app": "Alkalmazás újratöltése", // English: "Reload App"
        "new_window": "Új ablak", // English: "New Window"
        "open_trash": "Szemetes megnyitása", // English: "Open Trash"
        "pick_name_for_worker": "Válasszon nevet a munkásnak", // English: "Pick a name for your worker"
        "publish_as_serverless_worker": "Munkás közzététele", // English: "Publish as Worker"
        "toolbar.enter_fullscreen": "Teljes képernyő", // English: "Enter Full Screen"
        "toolbar.github": "GitHub", // English: "GitHub"
        "toolbar.refer": "Ajánlás", // English: "Refer"
        "toolbar.save_account": "Fiók mentése", // English: "Save Account"
        "toolbar.search": "Keresés", // English: "Search"
        "toolbar.qrcode": "QR-kód", // English: "QR Code"
        "used_of": "{{used}} használt a {{available}}-ból", // English: "{{used}} used of {{available}}"
        "worker": "Munkás", // English: "Worker"
        "billing.offering.basic": "Alap", // English: "Basic"
        "too_many_attempts": "Túl sok próbálkozás. Kérjük, próbálja meg később.", // English: "Too many attempts. Please try again later."
        "server_timeout": "A szerver túl sokáig válaszolt. Kérjük, próbálja meg újra.", // English: "The server took too long to respond. Please try again."
        "signup_error": "Hiba történt a regisztráció során. Kérjük, próbálja újra.", // English: "An error occurred during signup. Please try again."
        "welcome_title": "Üdvözöljük a Személyes Internet Számítógépén", // English: "Welcome to your Personal Internet Computer"
        "welcome_description": "Tároljon fájlokat, játsszon játékokat, fedezzen fel nagyszerű alkalmazásokat és még sok mást! Mindez egy helyen, bárhonnan és bármikor elérhető.", // English: "Store files, play games, find awesome apps, and much more! All in one place, accessible from anywhere at any time."
        "welcome_get_started": "Kezdés", // English: "Get Started"
        "welcome_terms": "Feltételek", // English: "Terms"
        "welcome_privacy": "Adatvédelem", // English: "Privacy"
        "welcome_developers": "Fejlesztők", // English: "Developers"
        "welcome_open_source": "Nyílt forráskód", // English: "Open Source"
        "welcome_instant_login_title": "Azonnali bejelentkezés!", // English: "Instant Login!"
        "alert_error_title": "Hiba!", // English: "Error!"
        "alert_warning_title": "Figyelmeztetés!", // English: "Warning!"
        "alert_info_title": "Információ", // English: "Info"
        "alert_success_title": "Siker!", // English: "Success!"
        "alert_confirm_title": "Biztos benne?", // English: "Are you sure?"
        "alert_yes": "Igen", // English: "Yes"
        "alert_no": "Nem", // English: "No"
        "alert_retry": "Újrapróbálkozás", // English: "Retry"
        "alert_cancel": "Mégse", // English: "Cancel"
        "signup_confirm_password": "Jelszó megerősítése", // English: "Confirm Password"
        "login_email_username_required": "E-mail vagy felhasználónév megadása kötelező", // English: "Email or username is required"
        "login_password_required": "Jelszó megadása kötelező", // English: "Password is required"
        "window_title_open": "Megnyitás", // English: "Open"
        "window_title_change_password": "Jelszó módosítása", // English: "Change Password"
        "window_title_select_font": "Betű kiválasztása…", // English: "Select font…"
        "window_title_session_list": "Munkamenet lista!", // English: "Session List!"
        "window_title_set_new_password": "Új jelszó beállítása", // English: "Set New Password"
        "window_title_instant_login": "Azonnali bejelentkezés!", // English: "Instant Login!"
        "window_title_publish_website": "Webhely közzététele", // English: "Publish Website"
        "window_title_publish_worker": "Munkás közzététele", // English: "Publish Worker"
        "window_title_authenticating": "Hitelesítés...", // English: "Authenticating..."
        "window_title_refer_friend": "Barát ajánlása!", // English: "Refer a friend!"
        "desktop_show_desktop": "Asztal megjelenítése", // English: "Show Desktop"
        "desktop_show_open_windows": "Megnyitott ablakok megjelenítése", // English: "Show Open Windows"
        "desktop_exit_full_screen": "Kilépés teljes képernyőből", // English: "Exit Full Screen"
        "desktop_enter_full_screen": "Teljes képernyő", // English: "Enter Full Screen"
        "desktop_position": "Pozíció", // English: "Position"
        "desktop_position_left": "Bal", // English: "Left"
        "desktop_position_bottom": "Alul", // English: "Bottom"
        "desktop_position_right": "Jobb", // English: "Right"
        "item_shared_with_you": "Egy felhasználó megosztotta Önnel ezt az elemet.", // English: "A user has shared this item with you."
        "item_shared_by_you": "Legalább egy másik felhasználóval megosztotta ezt az elemet.", // English: "You have shared this item with at least one other user."
        "item_shortcut": "Parancsikon", // English: "Shortcut"
        "item_associated_websites": "Kapcsolódó webhely", // English: "Associated website"
        "item_associated_websites_plural": "Kapcsolódó webhelyek", // English: "Associated websites"
        "no_suitable_apps_found": "Nem találhatók megfelelő alkalmazások", // English: "No suitable apps found"
        "window_click_to_go_back": "Kattintson a visszalépéshez.", // English: "Click to go back."
        "window_click_to_go_forward": "Kattintson a továbblépéshez.", // English: "Click to go forward."
        "window_click_to_go_up": "Kattintson a szülőmappa megnyitásához.", // English: "Click to go one directory up."
        "window_title_public": "Nyilvános", // English: "Public"
        "window_title_videos": "Videók", // English: "Videos"
        "window_title_pictures": "Képek", // English: "Pictures"
        "window_title_puter": "Puter", // English: "Puter"
        "window_folder_empty": "Ez a mappa üres", // English: "This folder is empty"
        "manage_your_subdomains": "Aldomainjeinek kezelése", // English: "Manage Your Subdomains"
        "open_containing_folder": "A tartalmazó mappa megnyitása", // English: "Open Containing Folder"

    }
};

export default hu;
